<template>
  <div>
    <div class="xttz-div" v-for="(item, index) in mysysmsg" :key="index">
      <img src="../../img/jblogo.png" alt />
      <div class="xttz-div-div">
        <div class="xttz-mydiv">
          <p class="xttz-mydiv-p">{{item.title}}</p>
          <p class="xttz-mydiv-p1">{{item.create_time_text}}</p>
        </div>
        <p class="xttz-div-div-p" v-html="item.content"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mysysmsg: ""
    };
  },
  methods: {},
  beforeCreate() {
    this.$http
      .post("user/mysysmsg/", {
        token: this.$cookies.get("token")
      })
      .then(res => {
        if (res.body.code == 1) {
          this.mysysmsg = res.body.data.data;
        }
      });
  }
};
</script>

<style  scoped="scoped">
.xttz-div {
  width: 100%;
  display: flex;
  margin-top: 10px;
}
.xttz-div > img {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  margin-right: 16px;
}
.xttz-div-div {
  padding: 10px 0;

  border-bottom: 1px solid #e6e6e6;
}
.xttz-mydiv {
  width: 782px;
  display: flex;
  justify-content: space-between;
}
.xttz-mydiv-p {
  color: #28a3b1;
  font-size: 14px;
}
.xttz-mydiv-p1 {
  color: #808080;
  font-size: 12px;
}
.xttz-div-div-p {
  width: 100%;
  font-size: 14px;
  margin-top: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Usercenter/xttz.vue